import { events, googleCalendarUrl, icsDataUrl } from '../common/calendar';

const schedules = [
  {
    key: 'sabado', label: 'SÁBADO 14 DE NOVIEMBRE', venue: 'Hotel Fiesta Inn Plaza San Marcos',
    items: [['13:30', 'Acceso y registro'], ['14:00', 'Entrenamiento'], ['18:00', 'Fin del entrenamiento'], ['18:10', 'Cena de calificación (5,000 PVT de octubre, previo registro)']]
  }
];

export default function Agenda() {
  return (
    <section className="section agenda-section" id="agenda">
      <div className="container">
        <div className="section-top"><span className="eyebrow">03 / PROGRAMA</span><span className="section-rule" /></div>
        <div className="section-intro"><h2>Cada momento<br /><span>cuenta.</span></h2><p>Planea tu tarde. Este es el programa del sábado 14 de noviembre.</p></div>
        <div className="agenda-grid single">
          {schedules.map((schedule) => (
            <div className="schedule" key={schedule.label}>
              <div className="schedule-header"><span>{schedule.label}</span><h3>{schedule.venue}</h3></div>
              <div className="schedule-list">
                {schedule.items.map(([time, description]) => (
                  <div className="schedule-row" key={time}><strong>{time}</strong><span>{description}</span><span className="schedule-dot" /></div>
                ))}
              </div>
              {(() => { const ev = events.find((e) => e.key === schedule.key); return ev && (
                <div className="calendar-actions">
                  <span className="calendar-label">Agregar a mi calendario</span>
                  <div className="calendar-buttons">
                    <a className="calendar-btn" href={googleCalendarUrl(ev)} target="_blank" rel="noreferrer">Google Calendar</a>
                    <a className="calendar-btn" href={icsDataUrl(ev)} download={`escuela-mayoristas-${ev.key}.ics`}>Apple / Outlook</a>
                  </div>
                </div>
              ); })()}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}